import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import {
  addYears,
  subDays,
  differenceInCalendarDays,
  addDays,
  startOfDay,
  parse,
} from 'date-fns';
import { NzModalService } from 'ng-zorro-antd/modal';
import { decisionFromScrutiny } from 'src/app/shared/utils/scrutiny-decision.util';
import { InspectionStorageService } from 'src/app/modules/course-accreditation/services/inspection-storage.service';
import { SaveInspectionDecisionDto } from 'src/app/modules/course-accreditation/DTO/saveInspectionDecisionDto';
import { StpRegistrationRenewReapplyService } from '../../../services/stp-registration-renew-reapply.service';

@Component({
  selector: 'app-final-decision',
  templateUrl: './final-decision.component.html',
  styleUrls: ['./final-decision.component.scss'],
})
export class FinalDecisionComponent implements OnInit {
  detailsInspectionReportList: any = [];
  inspectionDecisionInfo: any;
  recommendationTypeList: any;
  recommendationTypeListForRegistration: any;
  upDatedRemarks: FormControl = new FormControl();
  rollbackRemarks: FormControl = new FormControl('');
  inspectionId: number;
  stpMainId: number;
  applicationId: string;

  total: number;
  size: number = 10;
  page: number = 1;
  sortingKey: string;
  sortingValue: string;
  value: any = null;

  isVisible = false;
  isConfirmLoading = false;
  isVisibleAll = false;

  currentInspectionDetailsRow: any;
  detailsInspectionReportListCheckCount: number = 0;
  detailsInspectionReportListRowCount: number = 0;

  firstForm: FormGroup;
  secondForm: FormGroup;
  thirdForm: FormGroup;
  fourthForm: FormGroup;
  decisionForm: FormGroup;
  rowIdFormDataMap = new Map<number, any>(); // used to save the form data value of each row

  currentApplicationTypeId: number;

  isSubmitAll: boolean = true;

  currentValidFromDate: Date = new Date();
  currentDate: Date = new Date();
  tomorrow: Date = addDays(this.currentDate, 1);
  januaryFirst2020: Date = parse('2020-01-01', 'yyyy-MM-dd', new Date());
  rollbackBtnDisabled = false;
  enableSaveAndSubmitBtn: boolean = false;

  nsdaOfficerName: string;
  designation: string;

  approveId: number;
  notApproveId: number;
  onHoldId: number;

  isScrutinyDecisionCompleted: boolean = false;
  isRenewalApplication: boolean = false;
  isInvalidDecision: boolean = false;
  isRollbackRemarks: boolean = false;

  stpExpireDate: Date | null;

  type: any;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private inspectionStorageService: InspectionStorageService,
    private stpRegistrationRenewReapplyService: StpRegistrationRenewReapplyService,
    private notification: NzNotificationService,
    private modal: NzModalService,
  ) {}

  ngOnInit() {
    this.inspectionId = this.route.snapshot.params.inspectionId;
    this.type = this.route.snapshot.paramMap.get('type');
    if (this.type === 'renewal') {
      this.isRenewalApplication = true;
    } else {
      this.isRenewalApplication = false;
    }
    this.getInspectionDecisionResult();
    this.getInspectionRecommendationByType('D');
    this.createFirstForm();
    this.createThirdForm();
    this.createFourthForm();
    this.createSecondForm();

    this.decisionForm = this.fb.group({
      applications: this.fb.array([]),
    });
  }

  getStpExpirationDate() {
    this.stpRegistrationRenewReapplyService
      .readStpExpirationDate(this.stpMainId)
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.stpExpireDate = res.data ? new Date(res.data) : null;
          }
        },
      });
  }

  get applications(): FormArray {
    return this.decisionForm.get('applications') as FormArray;
  }

  updateSaveAndSubmitBtn(detailsInspectionReportList: any) {
    let isOnHold: boolean = false;
    let isDecisionComplete: boolean = false;
    for (let data of detailsInspectionReportList) {
      if (
        data['finalDecisionId'] ||
        data['finalDecisionCourseId'] ||
        data['finalDecisionAssessmentId']
      ) {
        isDecisionComplete = true;
        //   if (data['decisionFinalInspectionRecomAssessment'] == 'On-Hold' || data['decisionFinalInspectionRecomCourse'] == 'On-Hold') {
        //     isOnHold = true;
        //   }
      }

      // if (data['decisionFinalInspectionRecomAssessment'] == 'On-Hold' || data['decisionFinalInspectionRecomCourse'] == 'On-Hold') {
      //   isOnHold = true;
      // }
    }

    if (this.isScrutinyDecisionCompleted) {
      if (isDecisionComplete) {
        this.enableSaveAndSubmitBtn = true;
        this.isSubmitAll = false;
      } else {
        this.enableSaveAndSubmitBtn = false;
        this.isSubmitAll = true;
      }
    }
  }

  getInspectionDecisionResult() {
    this.stpRegistrationRenewReapplyService
      .readDecisionDetailsByInspectionId(this.inspectionId)
      .subscribe(
        (res) => {
          this.upDatedRemarks.setValue(res.data?.correctionRemarks);
          this.inspectionDecisionInfo = res['data'];

          this.stpMainId = this.inspectionDecisionInfo?.stpId;
          this.getStpExpirationDate();

          this.applicationId = res?.data?.applicationId;

          let nsdaOfficerId = res.data?.nsdaOfficer;
          this.isScrutinyDecisionCompleted =
            res.data?.isScrutinyDecisionCompleted;
          if (nsdaOfficerId != null) {
            this.getNsdaOfficer(nsdaOfficerId);
          }
          this.detailsInspectionReportList =
            this.inspectionDecisionInfo[
              'inspectionDecisionDetailsReportPayload'
            ];

          this.detailsInspectionReportListRowCount =
            this.detailsInspectionReportList.length;
          this.updateSaveAndSubmitBtn(this.detailsInspectionReportList);
          let rowCount = 1;

          this.detailsInspectionReportList.forEach((d: any) => {
            if (d.inspectionRegistrationReportId != null) {
              d['type'] = 'STP';
            } else d['type'] = 'Occupation';
            if (
              d.finalDecisionId ||
              d.finalDecisionCourseId ||
              d.finalDecisionAssessmentId
            ) {
              d['isUpdated'] = true;
            } else {
              d['isUpdated'] = false;
            }
            d['rowId'] = rowCount;
            rowCount += 1;
          });
          this.updateRowIdFormDataMap();
          this.updateDecisionFormArray();
        },
        (error) => {
          this.notification.error(
            'Error!',
            'Error getting scrutiny inspection result info',
          );
        },
      );
  }

  updateRowIdFormDataMap() {
    for (let d of this.detailsInspectionReportList) {
      let obj = {
        firstSelect: null,
        // validDateRange: [null, null],
        secondSelect: null,
        fromDate: null,
        toDate: null,
        fromDateLast: null,
        toDateLast: null,
        // validDateRangeLast: [null, null],
      };
      switch (d.applicationTypeId) {
        // case for Registration
        case 4:
          obj['firstSelect'] = d?.finalDecisionId;
          obj['fromDate'] = d.validFrom;
          obj['toDate'] = d.validTo;
          break;

        // case for Course Accreditation
        case 1:
          obj['firstSelect'] = d?.finalDecisionCourseId;
          obj['fromDate'] = d.validFromCourse;
          obj['toDate'] = d.validToCourse;
          break;

        // case for Assessment Center Accreditation
        case 2:
          obj['firstSelect'] = d?.finalDecisionAssessmentId;
          obj['fromDate'] = d.validFromAssessment;
          obj['toDate'] = d.validToAssessment;
          break;

        // case for Course and Assessment Center Accreditation
        case 3:
          obj['firstSelect'] = d?.finalDecisionCourseId;
          obj['fromDate'] = d?.validFromCourse;
          obj['toDate'] = d?.validToCourse;
          // obj['validDateRange'][0] = d.validFromCourse;
          // obj['validDateRange'][1] = d.validToCourse;

          obj['secondSelect'] = d?.finalDecisionAssessmentId;
          // obj['validDateRangeLast'][0] = d.validFromAssessment;
          // obj['validDateRangeLast'][1] = d.validToAssessment;
          obj['fromDateLast'] = d?.validFromAssessment;
          obj['toDateLast'] = d?.validToAssessment;

          break;
      }
      this.rowIdFormDataMap.set(d.rowId, obj);
    }
  }

  calculateAndSetCheckCount() {
    this.rowIdFormDataMap.forEach((item: any) => {
      if (item.firstSelect) {
        this.detailsInspectionReportListCheckCount++;
      }
    });
    if (
      this.detailsInspectionReportListRowCount ==
        this.detailsInspectionReportListCheckCount ||
      this.isSubmitAll == true
    ) {
      this.isSubmitAll = true;
    } else {
      this.isSubmitAll = false;
    }
  }

  updateStatusNameWithID(recommendationTypeList: any) {
    if (!recommendationTypeList) {
      return;
    }

    for (let recommendation of recommendationTypeList) {
      if (recommendation.name == 'Approved') {
        this.approveId = recommendation.id;
      } else if (recommendation.name == 'Not-Approved') {
        this.notApproveId = recommendation.id;
      } else if ((recommendation.name = 'On-Hold')) {
        this.onHoldId = recommendation.id;
      }
    }
  }

  getInspectionRecommendationByType(type: string) {
    this.inspectionStorageService
      .getInspectionRecommendationByType(type)
      .subscribe(
        (res) => {
          this.recommendationTypeList = res['data'];
          this.recommendationTypeListForRegistration = res['data'].filter(
            (d: any) => d.name != 'On-Hold',
          ); // remove On-Hold for Registration

          this.updateStatusNameWithID(this.recommendationTypeList);
        },
        (error) => {
          this.notification.error(
            'Error!',
            'Error getting recommendation type',
          );
        },
      );
  }

  getInspectionDecisionDtoList() {
    let saveInspectionDecisionDtoList: SaveInspectionDecisionDto[] = [];

    for (let d of this.detailsInspectionReportList) {
      let saveInspectionDecisionDto = new SaveInspectionDecisionDto();
      const formData = this.rowIdFormDataMap.get(d.rowId);

      switch (d.applicationTypeId) {
        // case for Registration
        case 4:
          saveInspectionDecisionDto.type = 'Registration';
          saveInspectionDecisionDto.inspectionRegistrationReportId =
            d.inspectionRegistrationReportId;
          saveInspectionDecisionDto.finalDecisionId = formData.firstSelect;

          if (formData?.fromDate && formData?.toDate) {
            saveInspectionDecisionDto.validFrom = formData.fromDate;
            saveInspectionDecisionDto.validTo = formData.toDate;
          } else {
            saveInspectionDecisionDto.validFrom = null as any;
            saveInspectionDecisionDto.validTo = null as any;
          }

          break;

        // case for Course Accreditation
        case 1:
          saveInspectionDecisionDto.type = 'Accreditation';
          saveInspectionDecisionDto.inspectionResultId = d.inspectionResultId;
          saveInspectionDecisionDto.finalDecisionCourseId =
            formData.firstSelect;

          if (formData?.fromDate && formData?.toDate) {
            saveInspectionDecisionDto.validFromCourse = formData.fromDate;
            saveInspectionDecisionDto.validToCourse = formData.toDate;
          } else {
            saveInspectionDecisionDto.validFromCourse = null as any;
            saveInspectionDecisionDto.validToCourse = null as any;
          }

          break;

        // case for Assessment Center Accreditation
        case 2:
          saveInspectionDecisionDto.type = 'Accreditation';
          saveInspectionDecisionDto.inspectionResultId = d.inspectionResultId;
          saveInspectionDecisionDto.finalDecisionAssessmentId =
            formData.firstSelect;

          if (formData?.fromDate && formData?.toDate) {
            saveInspectionDecisionDto.validFromAssessment = formData.fromDate;
            saveInspectionDecisionDto.validToAssessment = formData.toDate;
          } else {
            saveInspectionDecisionDto.validFromAssessment = null as any;
            saveInspectionDecisionDto.validToAssessment = null as any;
          }

          break;

        // case for Course and Assessment Center Accreditation
        case 3:
          saveInspectionDecisionDto.type = 'Accreditation';
          saveInspectionDecisionDto.inspectionResultId = d.inspectionResultId;
          saveInspectionDecisionDto.finalDecisionCourseId =
            formData.firstSelect;

          if (formData?.fromDate && formData?.toDate) {
            saveInspectionDecisionDto.validFromCourse = formData.fromDate;
            saveInspectionDecisionDto.validToCourse = formData.toDate;
          } else {
            saveInspectionDecisionDto.validFromCourse = null as any;
            saveInspectionDecisionDto.validToCourse = null as any;
          }

          saveInspectionDecisionDto.finalDecisionAssessmentId =
            formData.secondSelect;

          if (formData?.fromDateLast && formData?.toDateLast) {
            saveInspectionDecisionDto.validFromAssessment =
              formData.fromDateLast;
            saveInspectionDecisionDto.validToAssessment = formData.toDateLast;
          } else {
            saveInspectionDecisionDto.validFromAssessment = null as any;
            saveInspectionDecisionDto.validToAssessment = null as any;
          }
          break;
      }
      saveInspectionDecisionDtoList.push(saveInspectionDecisionDto);
    }

    return saveInspectionDecisionDtoList;
  }

  getNsdaOfficer(officer_id: number) {
    this.inspectionStorageService
      .getUserByUserId(officer_id)
      .subscribe((res) => {
        this.nsdaOfficerName = res?.name;
        this.designation = res?.designation;
      });
  }

  onView(inspectionResultId: number | null): void {
    // this.router.navigate([
    //   `home/course-accreditation-inspection-report/inspection-report-preview-shared/${inspectionResultId}`,
    // ]);

    const tree = this.router.createUrlTree([
      '/home/course-accreditation-inspection-report/inspection-report-preview-shared',
      inspectionResultId,
    ]);

    const url = this.router.serializeUrl(tree);
    const absoluteUrl = `${window.location.origin}/#${url}`;

    window.open(absoluteUrl, '_blank');
  }

  onViewStpSac(inspectionId: number): void {
    // this.router.navigate(
    //   [
    //     `home/course-accreditation/stp-sac-inspection-report-preview/${inspectionId}`,
    //   ],
    //   {
    //     queryParams: {
    //       type: 'view',
    //     },
    //   }
    // );

    const tree = this.router.createUrlTree(
      [
        `home/stp-registration/stp-sac-inspection-report-preview-renew-reapply/${inspectionId}`,
      ],
      {
        queryParams: { type: 'view' },
      },
    );

    const url = this.router.serializeUrl(tree);
    const absoluteUrl = `${window.location.origin}/#${url}`;

    window.open(absoluteUrl, '_blank');
  }

  onAssessmentDecisionSave() {
    this.checkDecisionValidation();

    if (!this.isInvalidDecision) {
      this.stpRegistrationRenewReapplyService
        .saveFinalDecision(this.applications.controls.map((row) => this.getApplicationValue(row)))
        .subscribe(
          (res) => {
            if (res['success']) {
              this.notification.success(
                'Success!',
                'Decision result saved successfully !',
              );
              this.onAssessmentDecisionSubmit();

              // this.isSubmitAll = true;
              // this.clearFormArray(this.applications);
              // this.getInspectionDecisionResult();
            } else {
              this.notification.error('Error!', res['message']);
            }
          },
          (error) => {
            this.notification.error(
              'Error!',
              'Error Saving scrutiny inspection decision result !',
            );
          },
        );
    }

    // let saveInspectionDecisionDtoList = this.getInspectionDecisionDtoList();

    // this.inspectionStorageService
    //   .saveScrutinyDecision(saveInspectionDecisionDtoList)
    //   .subscribe(
    //     (res) => {
    //       if (res['success']) {
    //         this.notification.success(
    //           'Success!',
    //           'Scrutiny Inspection Decision Result Information saved successfully'
    //         );
    //         this.calculateAndSetCheckCount();
    //       } else {
    //         this.notification.error('Error!', res['message']);
    //       }
    //     },
    //     (error) => {
    //       this.notification.error(
    //         'Error!',
    //         'Error Saving scrutiny inspection decision result'
    //       );
    //     }
    //   );
  }

  onAssessmentDecisionSubmit() {
    // this.checkDecisionValidation();

    // if(!this.isInvalidDecision){
    this.stpRegistrationRenewReapplyService
      .submitFinalDecision(this.inspectionId)
      .subscribe(
        (res) => {
          if (res['success']) {
            // this.notification.success('Success!', 'Decision result submitted successfully !');

            this.clearFormArray(this.applications);
            this.getInspectionDecisionResult();
            this.isVisibleAll = false;
            this.isSubmitAll = false;
            this.isRollbackRemarks = false;
            this.showNextPendingApplicationModal();

            // this.router.navigate(['../../course-accreditation-admin-list'], {
            //   relativeTo: this.route,
            // });
          } else {
            this.notification.error('Error!', res['message']);
          }
        },
        (error) => {
          this.notification.error(
            'Error!',
            'Error Submitting scrutiny inspection result',
          );
        },
      );
    // }
  }

  showNextPendingApplicationModal() {
    this.modal.success({
      nzTitle: 'Decision Submitted.',
      nzContent: 'Do you want to see the next application?',
      nzOkText: 'Yes',
      nzCancelText: 'No',
      nzOnOk: () => {
        this.redirectToNextPendingApplication();
      },
      nzOnCancel: () => {
        const path = this.isRenewalApplication
          ? '/home/stp-registration/stp-renewal-application-list'
          : '/home/stp-registration/stp-reapply-application-list';
        this.router.navigate([path]);
      },
    });
  }

  redirectToNextPendingApplication() {
    this.stpRegistrationRenewReapplyService
      .getNextRenewReapplyPendingDecisionInspectionId()
      .subscribe({
        next: (response) => {
          if (response?.success) {
            this.isSubmitAll = true;
            this.router.navigate([
              '/home/stp-registration/final-decision',
              response?.data,
              this.type,
            ]);
          } else {
            this.noPendingApplicationModal();
          }
        },
        error: () => {
          this.notification.error(
            'Error!',
            'Error finding next pending application !',
          );
        },
      });
  }

  noPendingApplicationModal() {
    this.modal.info({
      nzTitle: 'All Done !',
      nzContent: 'There are no more pending applications.',
      nzOnOk: () => {
        this.router.navigate(['/home/stp-registration/stp-applications'], {
          relativeTo: this.route,
        });
      },
    });
  }

  onAssesmentDecisionRollback() {
    const remarks = this.rollbackRemarks.value?.trim();

    if (!remarks) {
      this.isRollbackRemarks = true;
      this.notification.warning(
        'Warning!',
        'Please input rollback remarks first !',
      );
      return;
    }

    this.rollbackBtnDisabled = true;
    this.stpRegistrationRenewReapplyService
      .rollBackDecisionByInspectionId(this.inspectionId, remarks)
      .subscribe(
        (res) => {
          if (res['success']) {
            this.notification.success(
              'Success!',
              'Decision rolled back successfully !',
            );
            const path = this.isRenewalApplication
              ? '/home/stp-registration/stp-renewal-application-list'
              : '/home/stp-registration/stp-reapply-application-list';

            this.router.navigate([path]);
          } else {
            this.notification.error('Error!', res['message']);
            this.rollbackBtnDisabled = false;
          }
        },
        (error) => {
          this.notification.error(
            'Error!',
            'Error Rollback final decision',
          );
          this.rollbackBtnDisabled = false;
        },
      );
  }

  showRollbackRemarks() {
    this.isRollbackRemarks = true;
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    this.page = params.pageIndex;
    this.size = params.pageSize;
    params.sort.forEach((element: { value: string | null; key: string }) => {
      if (element.value != null) {
        this.sortingKey = element.key;
        this.sortingValue = element.value;
      }
    });
    // this.loadApplicatsFromServer();
  }

  showModal(rowData: any): void {
    this.currentApplicationTypeId = rowData.applicationTypeId;
    this.currentInspectionDetailsRow = rowData;
    this.isVisible = true;
    this.firstForm.reset();
    this.thirdForm.reset();
    this.fourthForm.reset();
    this.secondForm.reset();

    if (this.rowIdFormDataMap.has(rowData.rowId)) {
      if (this.currentApplicationTypeId == 3) {
        let values = this.rowIdFormDataMap.get(rowData.rowId);
        let {
          firstSelect,
          fromDate,
          toDate,
          secondSelect,
          fromDateLast,
          toDateLast,
        } = values;

        if (fromDate && toDate == null) {
          fromDate = [];
          toDate = [];
        }

        if (fromDateLast && toDateLast == null) {
          fromDateLast = [];
          toDateLast = [];
        }

        this.secondForm.patchValue({
          firstSelect,
          fromDate,
          toDate,
          secondSelect,
          fromDateLast,
          toDateLast,
        });

        if (this.secondForm.get('firstSelect')?.value == this.approveId) {
          this.secondForm.controls['fromDate'].enable();
          this.secondForm.controls['toDate'].enable();
        }

        if (this.secondForm.get('secondSelect')?.value == this.approveId) {
          this.secondForm.controls['fromDateLast'].enable();
          this.secondForm.controls['toDateLast'].enable();
        }

        this.secondForm.updateValueAndValidity();
      } else if (this.currentApplicationTypeId == 1) {
        let values = this.rowIdFormDataMap.get(rowData.rowId);
        let { firstSelect, fromDate, toDate } = values;

        if (fromDate && toDate == null) {
          fromDate = [];
          toDate = [];
        }

        this.thirdForm.patchValue({
          firstSelect,
          fromDate,
          toDate,
        });

        if (this.thirdForm.get('firstSelect')?.value == this.approveId) {
          this.thirdForm.controls['fromDate'].enable();
          this.thirdForm.controls['toDate'].enable();
        }

        this.thirdForm.updateValueAndValidity();
      } else if (this.currentApplicationTypeId == 2) {
        let values = this.rowIdFormDataMap.get(rowData.rowId);
        let { firstSelect, fromDate, toDate } = values;

        if (fromDate && toDate == null) {
          fromDate = [];
          toDate = [];
        }

        this.fourthForm.patchValue({
          firstSelect,
          fromDate,
          toDate,
        });

        if (this.fourthForm.get('firstSelect')?.value == this.approveId) {
          this.fourthForm.controls['fromDate'].enable();
          this.fourthForm.controls['toDate'].enable();
        }

        this.fourthForm.updateValueAndValidity();
      } else {
        let values = this.rowIdFormDataMap.get(rowData.rowId);
        let { firstSelect, fromDate, toDate } = values;

        if (fromDate && toDate == null) {
          fromDate = [];
          toDate = [];
        }

        this.firstForm.patchValue({
          firstSelect,
          fromDate,
          toDate,
        });

        if (this.firstForm.get('firstSelect')?.value == this.approveId) {
          this.firstForm.controls['fromDate'].enable();
          this.firstForm.controls['toDate'].enable();
        }

        this.firstForm.updateValueAndValidity();
      }
    }
  }

  handleOk(): void {
    if (this.currentApplicationTypeId == 3) {
      if (this.secondForm.invalid) {
        this.notification.info('info', 'Please input all required fields');
        return;
      }

      this.rowIdFormDataMap.set(
        this.currentInspectionDetailsRow.rowId,
        this.secondForm.getRawValue(),
      );
    } else if (this.currentApplicationTypeId == 1) {
      if (this.thirdForm.invalid) {
        this.notification.info('info', 'Please input all required fields');
        return;
      }

      this.rowIdFormDataMap.set(
        this.currentInspectionDetailsRow.rowId,
        this.thirdForm.getRawValue(),
      );
    } else if (this.currentApplicationTypeId == 2) {
      if (this.fourthForm.invalid) {
        this.notification.info('info', 'Please input all required fields');
        return;
      }

      this.rowIdFormDataMap.set(
        this.currentInspectionDetailsRow.rowId,
        this.fourthForm.getRawValue(),
      );
    } else {
      if (this.firstForm.invalid) {
        this.notification.info('info', 'Please input all required fields');
        return;
      }

      this.rowIdFormDataMap.set(
        this.currentInspectionDetailsRow.rowId,
        this.firstForm.getRawValue(),
      );
    }

    this.detailsInspectionReportList.forEach((d: any) => {
      if (d.rowId == this.currentInspectionDetailsRow.rowId) {
        d['isUpdated'] = true;
      }
    });

    this.isVisible = false;
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  createFirstForm() {
    this.firstForm = this.fb.group({
      firstSelect: ['', Validators.required],
      fromDate: [Date, Validators.required],
      toDate: [Date, Validators.required],
    });
  }

  createThirdForm() {
    this.thirdForm = this.fb.group({
      firstSelect: ['', Validators.required],
      fromDate: [Date, Validators.required],
      toDate: [Date, Validators.required],
    });
  }

  createFourthForm() {
    this.fourthForm = this.fb.group({
      firstSelect: ['', Validators.required],
      fromDate: [Date, Validators.required],
      toDate: [Date, Validators.required],
    });
  }

  createSecondForm() {
    this.secondForm = this.fb.group({
      firstSelect: ['', Validators.required],
      fromDate: [Date, Validators.required],
      toDate: [Date, Validators.required],
      secondSelect: ['', Validators.required],
      fromDateLast: [Date, Validators.required],
      toDateLast: [Date, Validators.required],
    });
  }

  // for not-approved and on-hold status, valid date range will be disabled
  onFirstSelectFirstForm(recommendId: any) {
    if (recommendId == this.notApproveId || recommendId == this.onHoldId) {
      this.firstForm.controls['fromDate'].reset();
      this.firstForm.controls['fromDate'].disable();
      this.firstForm.controls['toDate'].reset();
      this.firstForm.controls['toDate'].disable();
    } else if (recommendId == this.approveId) {
      this.firstForm.controls['fromDate'].enable();
      this.firstForm.controls['toDate'].enable();
      this.prefillApprovalDates(this.firstForm, 'fromDate', 'toDate', 5);
    } else {
      this.firstForm.controls['fromDate'].reset();
      this.firstForm.controls['fromDate'].disable();
      this.firstForm.controls['toDate'].reset();
      this.firstForm.controls['toDate'].disable();
    }
  }

  onFirstSelectThirdForm(recommendId: any) {
    if (recommendId == this.notApproveId || recommendId == this.onHoldId) {
      this.thirdForm.controls['fromDate'].reset();
      this.thirdForm.controls['fromDate'].disable();
      this.thirdForm.controls['toDate'].reset();
      this.thirdForm.controls['toDate'].disable();
    } else if (recommendId == this.approveId) {
      this.thirdForm.controls['fromDate'].enable();
      this.thirdForm.controls['toDate'].enable();
      this.prefillApprovalDates(this.thirdForm, 'fromDate', 'toDate', 2);
    } else {
      this.thirdForm.controls['fromDate'].reset();
      this.thirdForm.controls['fromDate'].disable();
      this.thirdForm.controls['toDate'].reset();
      this.thirdForm.controls['toDate'].disable();
    }
  }

  onFirstSelectFourthForm(recommendId: any) {
    if (recommendId == this.notApproveId || recommendId == this.onHoldId) {
      this.fourthForm.controls['fromDate'].reset();
      this.fourthForm.controls['fromDate'].disable();
      this.fourthForm.controls['toDate'].reset();
      this.fourthForm.controls['toDate'].disable();
    } else if (recommendId == this.approveId) {
      this.fourthForm.controls['fromDate'].enable();
      this.fourthForm.controls['toDate'].enable();
      this.prefillApprovalDates(this.fourthForm, 'fromDate', 'toDate', 2);
    } else {
      this.fourthForm.controls['fromDate'].reset();
      this.fourthForm.controls['fromDate'].disable();
      this.fourthForm.controls['toDate'].reset();
      this.fourthForm.controls['toDate'].disable();
    }
  }

  onFirstSelectSecondForm(recommendId: any) {
    if (recommendId == this.notApproveId || recommendId == this.onHoldId) {
      this.secondForm.controls['fromDate'].reset();
      this.secondForm.controls['fromDate'].disable();
      this.secondForm.controls['toDate'].reset();
      this.secondForm.controls['toDate'].disable();
    } else if (recommendId == this.approveId) {
      this.secondForm.controls['fromDate'].enable();
      this.secondForm.controls['toDate'].enable();
      this.prefillApprovalDates(this.secondForm, 'fromDate', 'toDate', 2);
    } else {
      this.secondForm.controls['fromDate'].reset();
      this.secondForm.controls['fromDate'].disable();
      this.secondForm.controls['toDate'].reset();
      this.secondForm.controls['toDate'].disable();
    }
  }

  onSecondSelectSecondForm(recommendId: any) {
    if (recommendId == this.notApproveId || recommendId == this.onHoldId) {
      this.secondForm.controls['fromDateLast'].reset();
      this.secondForm.controls['fromDateLast'].disable();
      this.secondForm.controls['toDateLast'].reset();
      this.secondForm.controls['toDateLast'].disable();
    } else if (recommendId == this.approveId) {
      this.secondForm.controls['fromDateLast'].enable();
      this.secondForm.controls['toDateLast'].enable();
      this.prefillApprovalDates(this.secondForm, 'fromDateLast', 'toDateLast', 2);
    } else {
      this.secondForm.controls['fromDateLast'].reset();
      this.secondForm.controls['fromDateLast'].disable();
      this.secondForm.controls['toDateLast'].reset();
      this.secondForm.controls['toDateLast'].disable();
    }
  }

  updateToDateFirstForm(fromDate: Date): void {
    const toDateControl = this.firstForm.get('toDate');
    if (fromDate) {
      const toDate = subDays(addYears(fromDate, 5), 1);
      toDateControl?.setValue(toDate);
    } else {
      toDateControl?.setValue(null);
    }
  }

  updateToDateThirdForm(fromDate: Date): void {
    const toDateControl = this.thirdForm.get('toDate');
    if (fromDate) {
      const toDate = subDays(addYears(fromDate, 2), 1);
      toDateControl?.setValue(toDate);
    } else {
      toDateControl?.setValue(null);
    }
  }

  updateToDateFourthForm(fromDate: Date): void {
    const toDateControl = this.fourthForm.get('toDate');
    if (fromDate) {
      const toDate = subDays(addYears(fromDate, 2), 1);
      toDateControl?.setValue(toDate);
    } else {
      toDateControl?.setValue(null);
    }
  }

  updateToDateSecondForm(fromDate: Date): void {
    const toDateControl = this.secondForm.get('toDate');
    if (fromDate) {
      const toDate = subDays(addYears(fromDate, 2), 1);
      toDateControl?.setValue(toDate);
    } else {
      toDateControl?.setValue(null);
    }
  }

  updateToDateLastSecondForm(fromDateLast: Date): void {
    const toDateLastControl = this.secondForm.get('toDateLast');
    if (fromDateLast) {
      const toDateLast = subDays(addYears(fromDateLast, 2), 1);
      toDateLastControl?.setValue(toDateLast);
    } else {
      toDateLastControl?.setValue(null);
    }
  }

  // STP start date: not before 2020, and not after today or the current STP expiry (whichever is later),
  // so a renewal approved before expiry can start from the expiry date (rule 5).
  disabledStpFromDate = (current: Date): boolean => {
    const today = startOfDay(this.currentDate);
    const expire = this.stpExpireDate ? startOfDay(new Date(this.stpExpireDate)) : null;
    const latest = expire && expire.getTime() > today.getTime() ? expire : today;
    return differenceInCalendarDays(current, latest) > 0 ||
      differenceInCalendarDays(current, startOfDay(this.januaryFirst2020)) <= 0;
  };

  // STP end date: any date from the start date on (5 years is only the pre-filled value). Cached per row.
  private stpToDateLimitCache = new Map<number, (current: Date) => boolean>();

  disabledStpToDate(index: number): (current: Date) => boolean {
    let fn = this.stpToDateLimitCache.get(index);
    if (!fn) {
      fn = (current: Date): boolean => {
        const value = this.applications.at(index)?.get('validFrom')?.value;
        if (!value) {
          return false;
        }
        return differenceInCalendarDays(current, startOfDay(new Date(value))) < 0;
      };
      this.stpToDateLimitCache.set(index, fn);
    }
    return fn;
  }

  // Start date picker: editable, and may be in the future (a renewal approved before expiry starts on the
  // current expiry date), so only dates up to 1 Jan 2020 are blocked
  disabledFromTodayDate = (current: Date): boolean => {
    return differenceInCalendarDays(current, startOfDay(this.januaryFirst2020)) <= 0;
  };

  showModalAllData(): void {
    this.clearFormArray(this.applications);
    this.updateDecisionFormArray();
    this.isVisibleAll = true;
  }

  clearFormArray(formArray: FormArray) {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  }

  updateDecisionFormArray() {
    this.detailsInspectionReportList.forEach((rowData: any, index: number) => {
      this.applications.push(this.createApplicationForm(rowData));
      this.onSelectDecision(index);
      this.updateToDateAllForm(index);
    });
  }

  createApplicationForm(rowData: any): FormGroup {
    const renewalValidFromDate = this.getRenewalValidFromDate(rowData);

    return this.fb.group({
      inspectionRegistrationReportId: [
        rowData?.inspectionRegistrationReportId ?? null,
      ],
      inspectionResultId: [rowData?.inspectionResultId ?? null],
      occupationName: [rowData?.occupationName ?? null],
      applicationType: [rowData?.applicationType ?? null],
      applicationTypeId: [rowData?.applicationTypeId ?? null],
      type: [
        rowData?.applicationTypeId == 4 ? 'Registration' : 'Accreditation',
      ],

      // Pre-loaded from the scrutiny result on every open; dates recalculated (start = the rule on
      // today's date, end = start + 5 years - 1 day), so a stale saved start date is never reused.
      finalDecisionId: [decisionFromScrutiny(rowData?.scrutinyResultRegistration)],
      validFrom: [
        {
          value:
            decisionFromScrutiny(rowData?.scrutinyResultRegistration) == 5
              ? this.getStpValidFromDate()
              : null,
          disabled: true,
        },
      ],
      validTo: [{ value: null, disabled: true }],
      scrutinyResultRegistration: [rowData?.scrutinyResultRegistration ?? null],

      finalDecisionCourseId: [
        rowData?.finalDecisionCourseId ??
          (rowData?.scrutinyResultForCourseAccreditation
            ? rowData?.scrutinyResultForCourseAccreditation === 'Recommended'
              ? 5
              : 6
            : null),
      ],
      validFromCourse: [
        {
          value:
            rowData?.validFromCourse ??
            (rowData?.scrutinyResultForCourseAccreditation === 'Recommended'
              ? renewalValidFromDate
              : null),
          disabled: true,
        },
      ],
      validToCourse: [
        { value: rowData?.validToCourse ?? null, disabled: true },
      ],
      scrutinyResultForCourseAccreditation: [
        rowData?.scrutinyResultForCourseAccreditation ?? null,
      ],

      finalDecisionAssessmentId: [
        rowData?.finalDecisionAssessmentId ??
          (rowData?.scrutinyResultForAssessmentCenterAccreditation
            ? rowData?.scrutinyResultForAssessmentCenterAccreditation ===
              'Recommended'
              ? 5
              : 6
            : null),
      ],
      validFromAssessment: [
        {
          value:
            rowData?.validFromAssessment ??
            (rowData?.scrutinyResultForAssessmentCenterAccreditation ===
            'Recommended'
              ? renewalValidFromDate
              : null),
          disabled: true,
        },
      ],
      validToAssessment: [
        { value: rowData?.validToAssessment ?? null, disabled: true },
      ],
      scrutinyResultForAssessmentCenterAccreditation: [
        rowData?.scrutinyResultForAssessmentCenterAccreditation ?? null,
      ],
    });
  }

  // Row value for validation and save: a start date is disabled unless the decision is Approved, so it is
  // taken from the raw value; a start date is only sent for an Approved decision.
  private getApplicationValue(row: AbstractControl): any {
    const raw = (row as FormGroup).getRawValue();
    return {
      ...row.value,
      validFrom: raw.finalDecisionId == 5 ? raw.validFrom : null,
      validFromCourse: raw.finalDecisionCourseId == 5 ? raw.validFromCourse : null,
      validFromAssessment: raw.finalDecisionAssessmentId == 5 ? raw.validFromAssessment : null,
    };
  }

  // Approved row: an empty start date is filled with the rule (STP: current expiry if still ahead,
  // otherwise today; course/center: previous approval expiry if still ahead, otherwise today), and an
  // empty end date with start + years - 1 day. The end date stays editable (any duration).
  private fillValidFrom(row: FormGroup, index: number, fromKey: string, toKey: string, years: number): void {
    if (!row.get(fromKey)?.value) {
      const from = years === 5
        ? this.getStpValidFromDate()
        : this.getRenewalValidFromDate(this.detailsInspectionReportList?.[index]) || startOfDay(new Date());
      row.get(fromKey)?.setValue(from, { emitEvent: false });
    }
    if (!row.get(toKey)?.value && row.get(fromKey)?.value) {
      row.get(toKey)?.setValue(subDays(addYears(new Date(row.get(fromKey)?.value), years), 1), { emitEvent: false });
    }
  }

  // STP/SAC approval start (rule 5): before the current STP expiry -> that expiry date; on or after it -> today.
  private getStpValidFromDate(): Date {
    const today = startOfDay(new Date());
    if (!this.stpExpireDate) {
      return today;
    }
    const expire = startOfDay(new Date(this.stpExpireDate));
    return expire.getTime() <= today.getTime() ? today : expire;
  }

  // Single-row popup: when Approve is chosen and the start date is still empty, pre-fill the start
  // (same rules as the full form) and the end (start + years - 1 day). Both stay editable.
  private prefillApprovalDates(form: FormGroup, fromKey: string, toKey: string, years: number): void {
    if (form.get(fromKey)?.value) {
      return;
    }
    const from = years === 5 ? this.getStpValidFromDate() : this.getRenewalValidFromDate(this.currentInspectionDetailsRow);
    if (!from) {
      return;
    }
    form.get(fromKey)?.setValue(from);
    form.get(toKey)?.setValue(subDays(addYears(from, years), 1));
  }

  private getRenewalValidFromDate(rowData: any): Date | null {
    const previousExpiryDate = rowData?.prevApprovalExpiryDate
      ? new Date(rowData.prevApprovalExpiryDate)
      : null;
    if (!previousExpiryDate || Number.isNaN(previousExpiryDate.getTime())) {
      return new Date();
    }

    // Same rule as the STP (rule 5): approved (today) before the previous expiry -> the new
    // period starts on that expiry date; on or after it -> today. Editable in the modal.
    const today = startOfDay(new Date());
    const previousExpiryOn = startOfDay(previousExpiryDate);
    return today.getTime() < previousExpiryOn.getTime() ? previousExpiryOn : today;
  }

  onSelectDecision(index: number) {
    const application = this.applications.at(index) as FormGroup;

    if (application.get('applicationTypeId')?.value == 1) {
      if (application.get('finalDecisionCourseId')?.value == 5) {
        this.fillValidFrom(application, index, 'validFromCourse', 'validToCourse', 2);
        application.get('validFromCourse')?.enable();
        application.get('validToCourse')?.enable();
      } else {
        application.get('validFromCourse')?.reset();
        application.get('validFromCourse')?.disable();
        application.get('validToCourse')?.reset();
        application.get('validToCourse')?.disable();
      }
    }

    if (application.get('applicationTypeId')?.value == 2) {
      if (application.get('finalDecisionAssessmentId')?.value == 5) {
        this.fillValidFrom(application, index, 'validFromAssessment', 'validToAssessment', 2);
        application.get('validFromAssessment')?.enable();
        application.get('validToAssessment')?.enable();
      } else {
        application.get('validFromAssessment')?.reset();
        application.get('validFromAssessment')?.disable();
        application.get('validToAssessment')?.reset();
        application.get('validToAssessment')?.disable();
      }
    }

    if (application.get('applicationTypeId')?.value == 3) {
      if (application.get('finalDecisionCourseId')?.value == 5) {
        this.fillValidFrom(application, index, 'validFromCourse', 'validToCourse', 2);
        application.get('validFromCourse')?.enable();
        application.get('validToCourse')?.enable();
      } else {
        application.get('validFromCourse')?.reset();
        application.get('validFromCourse')?.disable();
        application.get('validToCourse')?.reset();
        application.get('validToCourse')?.disable();
      }

      if (application.get('finalDecisionAssessmentId')?.value == 5) {
        this.fillValidFrom(application, index, 'validFromAssessment', 'validToAssessment', 2);
        application.get('validFromAssessment')?.enable();
        application.get('validToAssessment')?.enable();
      } else {
        application.get('validFromAssessment')?.reset();
        application.get('validFromAssessment')?.disable();
        application.get('validToAssessment')?.reset();
        application.get('validToAssessment')?.disable();
      }
    }

    if (application.get('applicationTypeId')?.value == 4) {
      if (application.get('finalDecisionId')?.value == 5) {
        this.fillValidFrom(application, index, 'validFrom', 'validTo', 5);
        application.get('validFrom')?.enable();
        application.get('validTo')?.enable();

        this.applications.controls.forEach((rowData: any) => {
          if (rowData.get('applicationTypeId')?.value != 4) {
            if (rowData.get('applicationTypeId')?.value == 1) {
              rowData.get('finalDecisionCourseId')?.enable();
            } else if (rowData.get('applicationTypeId')?.value == 2) {
              rowData.get('finalDecisionAssessmentId')?.enable();
            } else if (rowData.get('applicationTypeId')?.value == 3) {
              rowData.get('finalDecisionCourseId')?.enable();
              rowData.get('finalDecisionAssessmentId')?.enable();
            }
          }
        });
      } else if (application.get('finalDecisionId')?.value == 6) {
        application.get('validFrom')?.reset();
        application.get('validFrom')?.disable();
        application.get('validTo')?.reset();
        application.get('validTo')?.disable();

        this.applications.controls.forEach((rowData: any) => {
          if (rowData.get('applicationTypeId')?.value != 4) {
            if (rowData.get('applicationTypeId')?.value == 1) {
              rowData.get('finalDecisionCourseId')?.setValue(6);
              rowData.get('finalDecisionCourseId')?.disable();

              rowData.get('validFromCourse')?.reset();
              rowData.get('validFromCourse')?.disable();
              rowData.get('validToCourse')?.reset();
              rowData.get('validToCourse')?.disable();
            } else if (rowData.get('applicationTypeId')?.value == 2) {
              rowData.get('finalDecisionAssessmentId')?.setValue(6);
              rowData.get('finalDecisionAssessmentId')?.disable();

              rowData.get('validFromAssessment')?.reset();
              rowData.get('validFromAssessment')?.disable();
              rowData.get('validToAssessment')?.reset();
              rowData.get('validToAssessment')?.disable();
            } else if (rowData.get('applicationTypeId')?.value == 3) {
              rowData.get('finalDecisionCourseId')?.setValue(6);
              rowData.get('finalDecisionCourseId')?.disable();

              rowData.get('validFromCourse')?.reset();
              rowData.get('validFromCourse')?.disable();
              rowData.get('validToCourse')?.reset();
              rowData.get('validToCourse')?.disable();

              rowData.get('finalDecisionAssessmentId')?.setValue(6);
              rowData.get('finalDecisionAssessmentId')?.disable();

              rowData.get('validFromAssessment')?.reset();
              rowData.get('validFromAssessment')?.disable();
              rowData.get('validToAssessment')?.reset();
              rowData.get('validToAssessment')?.disable();
            }
          }
        });
      } else {
        application.get('validFrom')?.reset();
        application.get('validFrom')?.disable();
        application.get('validTo')?.reset();
        application.get('validTo')?.disable();
      }
    }
  }

  // STP row: the officer changed the start date, so the end date is recalculated (start + 5 years - 1 day)
  onValidFromChange(index: number): void {
    this.applications.at(index)?.get('validTo')?.setValue(null, { emitEvent: false });
    this.updateToDateAllForm(index);
  }

  updateToDateAllForm(index: number): void {
    const application = this.applications.at(index) as FormGroup;

    if (application.get('applicationTypeId')?.value == 1) {
      const validFromCourse: Date | null = application.get('validFromCourse')
        ?.value
        ? new Date(application.get('validFromCourse')?.value)
        : null;
      const validToCourseDateControl = application.get('validToCourse');
      if (
        application.get('finalDecisionCourseId')?.value == 5 &&
        validFromCourse
      ) {
        const validToCourseDate = subDays(addYears(validFromCourse, 2), 1);
        if (!validToCourseDateControl?.value) { validToCourseDateControl?.setValue(validToCourseDate); }
      } else {
        validToCourseDateControl?.setValue(null);
      }
    }

    if (application.get('applicationTypeId')?.value == 2) {
      const validFromAssessment: Date | null = application.get(
        'validFromAssessment',
      )?.value
        ? new Date(application.get('validFromAssessment')?.value)
        : null;
      const validToAssessmentDateControl = application.get('validToAssessment');
      if (
        application.get('finalDecisionAssessmentId')?.value == 5 &&
        validFromAssessment
      ) {
        const validToAssessmentDate = subDays(
          addYears(validFromAssessment, 2),
          1,
        );
        if (!validToAssessmentDateControl?.value) { validToAssessmentDateControl?.setValue(validToAssessmentDate); }
      } else {
        validToAssessmentDateControl?.setValue(null);
      }
    }

    if (application.get('applicationTypeId')?.value == 3) {
      const validFromCourse: Date | null = application.get('validFromCourse')
        ?.value
        ? new Date(application.get('validFromCourse')?.value)
        : null;
      const validToCourseDateControl = application.get('validToCourse');
      if (
        application.get('finalDecisionCourseId')?.value == 5 &&
        validFromCourse
      ) {
        const validToCourseDate = subDays(addYears(validFromCourse, 2), 1);
        if (!validToCourseDateControl?.value) { validToCourseDateControl?.setValue(validToCourseDate); }
      } else {
        validToCourseDateControl?.setValue(null);
      }

      const validFromAssessment: Date | null = application.get(
        'validFromAssessment',
      )?.value
        ? new Date(application.get('validFromAssessment')?.value)
        : null;
      const validToAssessmentDateControl = application.get('validToAssessment');
      if (
        application.get('finalDecisionAssessmentId')?.value == 5 &&
        validFromAssessment
      ) {
        const validToAssessmentDate = subDays(
          addYears(validFromAssessment, 2),
          1,
        );
        if (!validToAssessmentDateControl?.value) { validToAssessmentDateControl?.setValue(validToAssessmentDate); }
      } else {
        validToAssessmentDateControl?.setValue(null);
      }
    }

    if (application.get('applicationTypeId')?.value == 4) {
      const validFrom: Date | null = application.get('validFrom')?.value
        ? new Date(application.get('validFrom')?.value)
        : null;
      const validToDateControl = application.get('validTo');
      if (application.get('finalDecisionId')?.value == 5 && validFrom) {
        const validToDate = subDays(addYears(validFrom, 5), 1);
        if (!validToDateControl?.value) { validToDateControl?.setValue(validToDate); }
      } else {
        validToDateControl?.setValue(null);
      }
    }
  }

  checkDecisionValidation() {
    this.isInvalidDecision = false;

    this.applications.controls.forEach((rowData: any) => {
      let application = this.getApplicationValue(rowData);

      if (application?.applicationTypeId == 1) {
        if (!application?.finalDecisionCourseId) {
          this.isInvalidDecision = true;
          // this.notification.warning('Warning !', 'Please input all required fields !');
          return;
        } else if (
          application?.finalDecisionCourseId == 5 &&
          (!application?.validFromCourse || !application?.validToCourse)
        ) {
          this.isInvalidDecision = true;
          // this.notification.warning('Warning !', 'Please input all required fields !');
          return;
        }
      } else if (application?.applicationTypeId == 2) {
        if (!application?.finalDecisionAssessmentId) {
          this.isInvalidDecision = true;
          // this.notification.warning('Warning !', 'Please input all required fields !');
          return;
        } else if (
          application?.finalDecisionAssessmentId == 5 &&
          (!application?.validFromAssessment || !application?.validToAssessment)
        ) {
          this.isInvalidDecision = true;
          // this.notification.warning('Warning !', 'Please input all required fields !');
          return;
        }
      } else if (application?.applicationTypeId == 3) {
        if (!application?.finalDecisionCourseId) {
          this.isInvalidDecision = true;
          // this.notification.warning('Warning !', 'Please input all required fields !');
          return;
        } else if (
          application?.finalDecisionCourseId == 5 &&
          (!application?.validFromCourse || !application?.validToCourse)
        ) {
          this.isInvalidDecision = true;
          // this.notification.warning('Warning !', 'Please input all required fields !');
          return;
        } else if (!application?.finalDecisionAssessmentId) {
          this.isInvalidDecision = true;
          // this.notification.warning('Warning !', 'Please input all required fields !');
          return;
        } else if (
          application?.finalDecisionAssessmentId == 5 &&
          (!application?.validFromAssessment || !application?.validToAssessment)
        ) {
          this.isInvalidDecision = true;
          // this.notification.warning('Warning !', 'Please input all required fields !');
          return;
        }
      } else if (application?.applicationTypeId == 4) {
        if (!application?.finalDecisionId) {
          this.isInvalidDecision = true;
          // this.notification.warning('Warning !', 'Please input all required fields !');
          return;
        } else if (
          application?.finalDecisionId == 5 &&
          (!application?.validFrom || !application?.validTo)
        ) {
          this.isInvalidDecision = true;
          // this.notification.warning('Warning !', 'Please input all required fields !');
          return;
        }
      }
    });

    if (this.isInvalidDecision) {
      this.notification.warning(
        'Warning !',
        'Please input all required fields !',
      );
    }
  }

  handleCancelAll(): void {
    this.isRollbackRemarks = false;
    this.rollbackRemarks.reset('');
    this.isVisibleAll = false;
  }
}
